import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex h-full w-full flex-col gap-7 md:gap-9',
    filterButton:
      'flex-center hover:text-brand-400 h-8 border-0 px-0 hover:bg-inherit',
    filterButtonChildren:
      'flex-center group/filter gap-[6px] transition-none max-md:normal-case md:gap-2',
    filterIcon: 'group-hover/filter:[&>path]:stroke-brand-400 h-6 w-6',
    drawer: 'px-3 py-6 pb-0 sm:px-12 sm:py-12 sm:pb-0',
    resetButton:
      'text-secondary-hover mt-1 p-0 text-[12px] font-medium tracking-[1px] uppercase sm:mt-0 sm:text-sm',
    titleWrapper: 'flex items-center gap-2 sm:items-end md:justify-between',
    title: 'text-lg font-medium tracking-[1px] md:text-3xl',
    filters: '-mr-3 flex flex-col overflow-y-auto pr-3',
    filter: 'mb-2.5 flex flex-col gap-x-4 gap-y-2 first:mb-9.5 last:mb-8',
    filterTitle:
      'flex w-full items-center justify-between font-medium max-lg:cursor-pointer',
    footer:
      'sticky bottom-0 mt-auto flex bg-white pb-[10px] max-md:static md:-mx-9.5',
    showProductsButton:
      'w-full disabled:cursor-not-allowed disabled:bg-gray-300'
  },
  variants: {
    hide: {
      true: {
        filterTitle: 'hidden'
      }
    },
    isNextCheckbox: {
      true: {
        filter: 'mb-1'
      }
    }
  },
  defaultVariants: {}
});
